import request from 'utils/Httprequest';
const prefixed = '/api/braintrain-service-photon';

export default {
  // 群发消息详情
  sendMessageGroupMessageInfo(data) {
    const { studentNum, todoMessageId, isSelfCreate } = data;
    const afterParam = !Number(isSelfCreate) ? `?studentNum=${studentNum}&todoMessageId=${todoMessageId}` : `?studentNum=${studentNum}&historyId=${todoMessageId}`;
    return request({
      url: `${prefixed}/workbench/groupMessage/info${afterParam}`,
      method: 'GET',
    });
  },
  // 通知发送对象分页列表
  sendMessageNotifyUserPage(data) {
    return request({
      url: `${prefixed}/workbench/notifyUserNew/page`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 通知发送对象全选id列表
  sendMessageNotifyUserSelectedAllList(data) {
    return request({
      url: `${prefixed}/workbench/notifyUserNew/list`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 通知发送对象列表
  sendMessageGroupMessageSend(data) {
    return request({
      url: `${prefixed}/workbench/groupMessage/send`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 通知发送对象列表
  sendMessageRestartSend(data) {
    return request({
      url: `${prefixed}/workbench/groupMessage/restartSend`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 发送结果列表
  sendMessageSendResultList(data) {
    return request({
      url: `${prefixed}/workbench/sendResult/list`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 发送历史列表
  sendMessageSendHistoryList(data) {
    return request({
      url: `${prefixed}/workbench/sendHistory/list`,
      method: 'post',
      json: true,
      data: data,
    });
  },

  // 发送结果id列表
  sendMessageSendResultIdList(data) {
    return request({
      url: `${prefixed}/workbench/sendResultId/list`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 插入参数
  sendMessageParamConfigList(data) {
    return request({
      url: `${prefixed}/workbench/paramConfig/list`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 获取群列表
  sendMessageNotifyGruopList(data) {
    return request({
      url: `${prefixed}/workbench/notifyGroup/list`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 获取员工小程序列表
  sendMessageAppletList(data) {
    return request({
      url: `${prefixed}/workbench/applet/list`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 获取员工小程序详情
  sendMessageAppletDetail(data) {
    return request({
      url: `${prefixed}/workbench/applet/detail/get?id=${data}`,
      method: 'GET',
    });
  },
};


